import { layout } from "@demo-data/layout";
import { FigmaIcon, LogoImg } from "@images/svg";
import { Container, Divider, Grid, Typography } from "@mui/material";
import { Box, Stack, useTheme } from "@mui/system";

export default function Footer() {
  const theme = useTheme();
  const {
    socials,
    socialsTitle,
    description,
    link,
    copyRight,
    logoTitle,
    refText,
  } = layout?.footer || {};
  return (
    <Container maxWidth="lg">
      <Divider />
      <Stack spacing={8} mt={8}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} justifyContent={"center"}>
            <Stack spacing={4}>
              <Stack
                direction={{ xs: "column", md: "row" }}
                alignItems={"center"}
                spacing={6}
                textAlign={"center"}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  component="a"
                  href="/"
                  sx={{
                    cursor: "pointer",
                  }}
                >
                  <LogoImg iconColor={theme.palette.text.primary} />
                  <Typography fontWeight={800} color="text.primary">
                    {logoTitle}
                  </Typography>
                </Stack>
                <Typography
                  color="text.primary"
                  component={"a"}
                  href="/"
                  className="anim-link"
                  fontSize={{
                    xs: 14,
                    sm: 16,
                  }}
                >
                  {link}
                </Typography>
              </Stack>

              <Typography
                fontSize={{
                  xs: 14,
                  sm: 16,
                }}
                fontWeight={400}
                align="center"
                color="text.secondary"
              >
                {description}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack alignItems="center" justifyContent="center">
              <Typography color="text.primary">{socialsTitle}</Typography>
              <Stack direction="row" py={1} gap={1}>
                {socials.map((item) => {
                  return (
                    <Box
                      component={"a"}
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={item.name}
                      title={item.name}
                      key={Math.random()}
                      sx={{
                        color: theme.palette.text.primary,
                        transition: "transform 0.3s ease, color 0.3s ease",
                        "&:hover": {
                          transform: "translateY(-4px) rotate(6deg)",
                          color: "primary.main",
                        },
                      }}
                    >
                      {item.img}
                    </Box>
                  );
                })}
              </Stack>
              <Stack justifyContent="center" alignItems="center">
                {refText && (
                  <>
                    <Typography
                      fontSize="12px"
                      fontWeight={400}
                      color="text.primary"
                      textAlign={"center"}
                    >
                      {refText}
                    </Typography>
                    <Box>
                      <Box
                        component={"a"}
                        href={
                          "https://www.figma.com/community/file/1164933568884615740"
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Design credit on Figma"
                        title="Design credit on Figma"
                      >
                        <FigmaIcon color={theme.palette.text.primary} />
                      </Box>
                    </Box>
                  </>
                )}
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Typography
          fontSize="12px"
          fontWeight={400}
          color="text.primary"
          textAlign={"center"}
          py={2}
        >
          © {new Date().getFullYear()} {copyRight}
        </Typography>
      </Stack>
    </Container>
  );
}
